const DefendSlogan = () => {
  return (
    <div className="py-[46px] text-center">
      <div className="font-[Rockwell] 2xl:text-[50px] xl:text-[40px] lg:text-[35px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold">
        ALL STEEL UTILITY VEHICLE
      </div>
      <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
        Experience the difference with Tuatara—the utility vehicle built to evolve and excel. Explore our range of
        models and discover why Tuatara is the go-to choice for those who demand performance, reliability, and
        sustainability.
      </div>
    </div>
  );
};
export default DefendSlogan;
